import Cookies from 'js-cookie'

const TokenKey = 'vue_admin_template_token'
// 为了穿越登录服务
const OriginToken = 'pre_cross_login_token'

export function getToken () {
  return Cookies.get(TokenKey)
}
export function getOriginToken () {
  return Cookies.get(OriginToken)
}

export function setToken (token) {
  return Cookies.set(TokenKey, token)
}

export function setOriginToken (token) {
  return Cookies.set(OriginToken, token)
}

export function removeToken () {
  return Cookies.remove(TokenKey)
}

export function removeOriginToken () {
  return Cookies.remove(OriginToken)
}

export function setVersion (version) {
  window.localStorage.setItem('callVersion', version)
}
export function getVersion () {
  return window.localStorage.getItem('callVersion')
}



// WEBPACK FOOTER //
// ./src/utils/auth.js